// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2MFkZ","header":"Messages_header__Ux_Bf"};